var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{class:{ 'modern-theme': _vm.modernTheme, 'app-font': _vm.modernTheme }},[_c('router-view'),_c('theme-selection-dialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }